import { DataSource, Layout, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementPayrollHistoryList extends Layout {
    searchpanelPayroll: SearchPanel;
    sourceDrsPayrollHist: DataSource;
    switchSwitchProcessed: Switch;
    switchSwitchVoided: Switch;
    tablePayrollList: Table;
    textboxCheckAmount: Textbox;
    textboxCheckDate: Textbox;
    textboxCheckNumber: Textbox;
    textboxFactCompany: Textbox;
    textboxPayeeCode: Textbox;
    textboxPayeeMethod: Textbox;
    textboxPaymentMethod: Textbox;
    textboxSource: Textbox;
    textboxVoidDate: Textbox;
}
